import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const navLinks = [{
  label: "What's Inside",
  href: '#product'
}, {
  label: 'Reviews',
  href: '#testimonials'
}, {
  label: 'FAQ',
  href: '#faq'
}];
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const handleClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    el?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <nav className={`sticky top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#060B18]/95 backdrop-blur-md shadow-lg shadow-black/20' : 'bg-[#060B18]'}`} data-id="element-189">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-190">
        <a href="#" className="font-display font-bold text-xl text-white" data-id="element-191">
          Founder<span className="text-teal" data-id="element-192">Vault</span>
        </a>

        <div className="hidden md:flex items-center gap-8" data-id="element-193">
          {navLinks.map(link => <button key={link.href} onClick={() => handleClick(link.href)} className="text-sm text-white/70 hover:text-white transition-colors font-medium" data-id="element-194">
              {link.label}
            </button>)}
          <button onClick={() => handleClick('#final-cta')} className="bg-gradient-teal text-white text-sm font-semibold px-5 py-2 rounded-full hover:shadow-lg hover:shadow-teal/30 transition-all duration-300" data-id="element-195">
            Get Access $59.99
          </button>
        </div>

        <button onClick={() => setMobileOpen(!mobileOpen)} className="md:hidden p-2 text-white/80" aria-label="Toggle menu" data-id="element-196">
          {mobileOpen ? <XIcon className="w-6 h-6" data-id="element-197" /> : <MenuIcon className="w-6 h-6" data-id="element-198" />}
        </button>
      </div>

      <AnimatePresence data-id="element-199">
        {mobileOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="md:hidden overflow-hidden bg-[#060B18] border-t border-white/5" data-id="element-200">
            <div className="px-4 py-4 flex flex-col gap-3" data-id="element-201">
              {navLinks.map(link => <button key={link.href} onClick={() => handleClick(link.href)} className="text-left text-white/70 hover:text-white py-2 text-sm font-medium transition-colors" data-id="element-202">
                  {link.label}
                </button>)}
              <button onClick={() => handleClick('#final-cta')} className="bg-gradient-teal text-white text-sm font-semibold px-5 py-2.5 rounded-full mt-2 hover:shadow-lg hover:shadow-teal/30 transition-all" data-id="element-203">
                Get Access $57
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}